// import { useParams } from '@remix-run/react';
import { useTranslation } from 'react-i18next';
import { ButtonLink } from '~/components/common/buttons/ButtonLink';
import FavoriteBtn from '~/components/common/office/FavoriteBtn';
import SVGIcon from '~/components/ui/Icons/SVGIcon';
import type { CoreOfficeDataType } from '~/types/offices';

export const MobileTopNav = ({ office, referer }: { office: CoreOfficeDataType; referer: string }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="d-md-none px-4 py-3">
        <div className="d-flex justify-content-between">
          <ButtonLink
            variant={'primaryLight'}
            to={referer}
            extraClasses={'ps-0'}
          >
            <SVGIcon iconType="chevron-left" />
            <span className="text-1 -medium ms-2">{t('global.btns.back')}</span>
          </ButtonLink>
          <div className="d-flex mt-1">
            <FavoriteBtn
              office={office}
              extraClasses="-primary -sm ms-6"
            />
          </div>
        </div>
      </div>
    </>
  );
};
